import React, { useEffect, useMemo, useRef, useState } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { isEmpty } from "lodash"
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css"
import TableContainer from "../../components/Common/TableContainer"
import * as Yup from "yup"
import { useFormik } from "formik"
import * as url from "../../helpers/url_helper"

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb"
import DeleteModal from "../../components/Common/DeleteModal"
//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { toast } from "react-toastify"

import {
  getToysGrouped as onGetToys, // Use grouped API
  addNewToy as onAddNewToy,
  updateToy as onUpdateToy,
  deleteToy as onDeleteToy,
  getCategories as onGetCategories,
  getAgeGroups as onGetAgeGroups,
  getCities as onGetCities,
  updateToy,
  addNewToy,
} from "store/actions"

//redux
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"

import {
  Button,
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  CardText,
  Table,
  Badge,
} from "reactstrap"
import moment from "moment"
import Spinners from "components/Common/Spinner"
import { ToastContainer } from "react-toastify"
import classnames from "classnames"
import { ORDER_STATUS } from "constants/AppConstants"
import { post, put, get } from "helpers/api_helper"
import { getToyById } from "helpers/toys_helper"

//react-select for multi select.
import Select from "react-select"
import ChangeToyStatusModal from "components/Common/ChangeToyStatusModal"

function Toys() {
  //meta title
  document.title = "Toys List"

  const [limit, setLimit] = useState(10)
  const [page, setPage] = useState(1)
  const [toyStatusFilter, setToyStatusFilter] = useState("all")
  const [toyCategoryFilter, setToyCategoryFilter] = useState("all")
  const [query, setQuery] = useState("")
  const [modal, setModal] = useState(false)
  const [modal1, setModal1] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [isAddUnitMode, setIsAddUnitMode] = useState(false)
  const [activeTab, setactiveTab] = useState("1")

  const [toy, setToy] = useState(null)
  const [cityPricing, setCityPricing] = useState([])
  const [formCityPricing, setFormCityPricing] = useState([]) // Separate state for form data
  const [toyShowFilter, setToyShowFilter] = useState("all")
  const [toyFeaturedFilter, setToyFeaturedFilter] = useState("all")
  const [deletedPhotos, setDeletedPhotos] = useState([])
  const [photoDeleteModal, setPhotoDeleteModal] = useState(false)
  const [photoToDelete, setPhotoToDelete] = useState(null)

  const handleDeleteImage = key => {
    setPhotoToDelete(key)
    setPhotoDeleteModal(true)
  }

  const confirmDeletePhoto = async () => {
    if (photoToDelete) {
      try {
        if (toy?._id && toy?._id !== 0) {
          const res = await post("toys/deleteImage", {
            _id: toy._id,
            key: photoToDelete,
          })
          if (res.status === 200) {
            toast.success("Photo deleted successfully")
          } else {
            toast.error("Failed to delete photo")
            return
          }
        }

        setDeletedPhotos(prev => [...prev, photoToDelete])
        if (photoToDelete === "defaultPhoto")
          setDefaultPhoto({ src: null, error: null, uploading: false })
        if (photoToDelete === "photo2")
          setSecondPhoto({ src: null, error: null, uploading: false })
        if (photoToDelete === "photo3")
          setThirdPhoto({ src: null, error: null, uploading: false })
        setPhotoDeleteModal(false)
        setPhotoToDelete(null)
      } catch (error) {
        console.log("Error in confirmDeletePhoto::", error)
        toast.error("Error in deleting photo")
      }
    }
  }

  const cancelDeletePhoto = () => {
    setPhotoDeleteModal(false)
    setPhotoToDelete(null)
  }

  const [selectedCity, setSelectedCity] = useState("All")

  const [defaultPhoto, setDefaultPhoto] = useState({
    src: null,
    error: null,
    uploading: false,
  })
  const [secondPhoto, setSecondPhoto] = useState({
    src: null,
    error: null,
    uploading: false,
  })
  const [thirdPhoto, setThirdPhoto] = useState({
    src: null,
    error: null,
    uploading: false,
  })

  const [isSubmitting, setIsSubmitting] = useState(false)
  const [bulkUpdateModal, setBulkUpdateModal] = useState(false) // Modal for bulk update confirmation
  const [pendingValues, setPendingValues] = useState(null) // Values to submit after confirmation

  const executeSubmit = async (values, isBulk = false) => {
    if (!toy?._id && isEdit) {
      toast.error("Toy ID is missing, cannot update.");
      return;
    }
    
    setIsSubmitting(true)
    try {
      const categoryString = Array.isArray(values.categories) ? values.categories.join(",") : ""
      const ageGroupString = Array.isArray(values.ageGroup) ? values.ageGroup.join(",") : ""
      if (isEdit) {
        const _cityPricing = formCityPricing.map(city => {
          return { ...city, city: (city?.city?._id || city?.city)?.toString() }
        })

        const updateToyData = {
          _id: toy ? toy._id : 0,
          status: values.status,
          name: values.toyName,
          category: categoryString,
          ageGroup: ageGroupString, 
          mrp: values.mrp,
          purchase: values.purchase,
          description: values.description,
          brand: values.brand,
          youtubeUrl: values.youtubeUrl,
          cityPricing: _cityPricing,
          showOnWebsite: showOnWebsite,
          deposit: values.deposit,
          purchaseSource: values.purchaseSource,
          purchaseDate: values.purchaseDate,
          featured: featured,
          deletedPhotos: deletedPhotos,
          defaultPhoto: defaultPhoto.src,
          photo2: secondPhoto.src,
          photo3: thirdPhoto.src,
        }

        // update toy
        let res
        if (isBulk) {
          res = await put(url.UPDATE_TOY_BULK + "/" + toy._id, updateToyData)
        } else {
          res = await put(url.TOYS + "/" + toy._id, updateToyData)
        }

        if (res) {
          toast.success(
            isBulk
              ? "All units updated successfully"
              : "Toy updated successfully",
          )
          // If quantity > 1, we add (quantity - 1) more units to match the total target
          if (values.quantity > 1) {
            const extraUnits = {
              status: values["status"],
              name: values["toyName"],
              category: Array.isArray(values["categories"])
                ? values["categories"]
                : [values["categories"]],
              ageGroup: Array.isArray(values["ageGroup"])
                ? values["ageGroup"]
                : [values["ageGroup"]],
              mrp: values["mrp"],
              purchase: values["purchase"],
              description: values["description"],
              brand: values["brand"],
              showOnWebsite: showOnWebsite,
              featured: featured,
              quantity: values.quantity - 1, // We already have 1 (the one we just updated)
              cityPricing: formCityPricing,
              deposit: values.deposit,
              purchaseSource: values.purchaseSource,
              purchaseDate: values.purchaseDate,
              youtubeUrl: values.youtubeUrl,
              defaultPhoto: toy.defaultPhoto,
              photo2: toy.photo2,
              photo3: toy.photo3,
              originalCode: toy?.code,
            }
            dispatch(onAddNewToy(extraUnits))
            validation.setFieldValue("quantity", 1)
          }
          dispatch(
            onGetToys(
              page,
              limit,
              query,
              toyStatusFilter,
              toyCategoryFilter,
              selectedCity,
              toyShowFilter,
              toyFeaturedFilter,
            ),
          )
        }
        validation.resetForm()
        toggle()
        setDeletedPhotos([])
      } else {
        const _cityPricing = formCityPricing.map(city => {
          return { ...city, city: (city?.city?._id || city?.city)?.toString() }
        })

        const newToy = {
          status: values["status"],
          name: values["toyName"],
          category: Array.isArray(values["categories"])
            ? values["categories"]
            : [values["categories"]],
          ageGroup: Array.isArray(values["ageGroup"])
            ? values["ageGroup"]
            : [values["ageGroup"]],
          mrp: values["mrp"],
          purchase: values["purchase"],
          description: values["description"],
          brand: values["brand"],
          showOnWebsite: showOnWebsite,
          featured: featured,
          quantity: values.quantity,
          cityPricing: _cityPricing, // Include pricing
          deposit: values.deposit,
          purchaseSource: values.purchaseSource,
          purchaseDate: values.purchaseDate,
          youtubeUrl: values.youtubeUrl,
          defaultPhoto: defaultPhoto.src,
          photo2: secondPhoto.src,
          photo3: thirdPhoto.src,
          originalCode: toy?.code,
        }

        dispatch(onAddNewToy(newToy))
        validation.setFieldValue("quantity", 0) // Reset to avoid double submission on possible re-render
        validation.resetForm()
        toggle()
      }
    } catch (error) {
      console.error("Submission failed", error)
      toast.error("Failed to save toy")
    } finally {
      setIsSubmitting(false)
    }
  }

  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      status: (toy && toy.status) || "",
      toyName: (toy && toy.name) || "",
      category: (toy && toy.category?._id) || [],
      ageGroup: (toy && toy.ageGroup && toy.ageGroup.map(age => age._id)) || "",
      mrp: (toy && toy.mrp) || "",
      purchase: (toy && toy.purchase) || "",
      description: (toy && toy.description) || "",
      brand: (toy && toy.brand) || "",
      youtubeUrl: (toy && toy.youtubeUrl) || "",
      showOnWebsite: (toy && toy.showOnWebsite) || false,
      featured: (toy && toy.featured) || false,
      categories:
        (toy && toy.category && toy.category.map(category => category._id)) ||
        [],
      deposit: (toy && toy.deposit) || "",
      purchaseSource: (toy && toy.purchaseSource) || "",
      purchaseDate: (toy && toy.purchaseDate) || "",
      quantity: isEdit || isAddUnitMode ? 1 : 1, // Start at 1 to represent the 'primary' unit being added/edited
    },
    validationSchema: Yup.object({
      status: Yup.string().required("Please select status"),
      toyName: Yup.string().required("Please Enter Your Toy Name"),
      categories: Yup.array()
        .required("Please select at least one category")
        .min(1, "Please select at least one category"),
      ageGroup: Yup.array()
        .required("Age Group")
        .min(1, "Please select at least one Age Group"),
      showOnWebsite: Yup.boolean(),
      featured: Yup.boolean(),
      quantity: Yup.number().min(0, "Quantity cannot be negative"),
    }),
    onSubmit: async values => {
      if (isEdit) {
        setPendingValues(values)
        setBulkUpdateModal(true)
      } else {
        await executeSubmit(values)
      }
    },
  })

  //Toy availability Toggle:
  const [showOnWebsite, setShowOnWebsite] = useState(
    validation.values.showOnWebsite || false,
  )
  const [featured, setFeatured] = useState(validation.values.featured || false)

  const toggleViewModal = () => setModal1(!modal1)

  const dispatch = useDispatch()

  const selectToyState = state => state.Toy
  const ToyProperties = createSelector(selectToyState, Toy => ({
    toys: Toy.toys,
    totalPages: Toy.totalPages, // This is explicitly mapped in reducer for grouped API
    loading: Toy.loading,
    addedToy: Toy.addedToy,
    showOnWebsite: Toy.showOnWebsite,
    featured: Toy.featured,
  }))

  const { toys, loading, addedToy, totalPages } = useSelector(ToyProperties)

  const selectCityState = state => state.City
  const CityProperties = createSelector(selectCityState, City => ({
    cities: City.cities,
  }))

  const { cities } = useSelector(CityProperties)

  const selectCategoryState = state => state.Category
  const CategoryProperties = createSelector(selectCategoryState, Category => ({
    categories: Category.categories,
  }))
  const { categories } = useSelector(CategoryProperties)
  const options = categories.map(category => ({
    label: category.name,
    value: category._id,
  }))

  //Get Age Groups
  const selectAgeGroupState = state => state.AgeGroup
  const AgeGroupProperties = createSelector(selectAgeGroupState, AgeGroup => ({
    ageGroups: AgeGroup.ageGroups,
  }))
  const { ageGroups } = useSelector(AgeGroupProperties)

  const ageGroupOptions = ageGroups.map(age => ({
    label: `${age.fromAge} - ${age.toAge} Years`,
    value: age._id,
  }))

  const [isLoading, setLoading] = useState(loading)

  useEffect(() => {
    dispatch(onGetCategories())
    dispatch(onGetAgeGroups())
    dispatch(onGetCities())
  }, [dispatch])

  useEffect(() => {
    dispatch(
      onGetToys(
        page,
        limit,
        query,
        toyStatusFilter,
        toyCategoryFilter,
        selectedCity,
        toyShowFilter,
        toyFeaturedFilter,
      ),
    )
  }, [
    page,
    limit,
    query,
    toyStatusFilter,
    toyCategoryFilter,
    toyShowFilter,
    toyFeaturedFilter,
    selectedCity,
    dispatch,
  ])

  useEffect(() => {
    if (addedToy) {
      setToy(addedToy)
      setIsEdit(true)
      setactiveTab("photoVideo")
      dispatch(
        onGetToys(
          page,
          limit,
          query,
          toyStatusFilter,
          toyCategoryFilter,
          selectedCity,
          toyShowFilter,
          toyFeaturedFilter,
        ),
      )
    }
  }, [addedToy])

  useEffect(() => {
    if (!cities || cities.length === 0) {
      return
    }

    let _cityPricing = []
    cities.forEach(cityObj => {
      const cityId = cityObj._id?.toString()

      // Look for existing pricing for this city in the current toy
      const priceMatch = toy?.cityPricing?.find(p => {
        const pCityId = (p.city?._id || p.city)?.toString()
        return pCityId === cityId
      })

      if (priceMatch) {
        _cityPricing.push({
          ...priceMatch,
          city: cityObj, // Always use the full object from cities array to ensure .name is available
        })
      } else {
        _cityPricing.push({
          city: cityObj,
          w2: 0,
          w3: 0,
          w4: 0,
          active: false,
        })
      }
    })

    setFormCityPricing(_cityPricing)
    setCityPricing(_cityPricing)
  }, [cities, toy])

  //reset modal content once pop up closed
  useEffect(() => {
    if (!modal) {
      // Refresh the list to ensure proper grouping and display of added/updated units
      dispatch(
        onGetToys(
          page,
          limit,
          query,
          toyStatusFilter,
          toyCategoryFilter,
          selectedCity,
          toyShowFilter,
          toyFeaturedFilter,
        ),
      )

      setModal(false)
      setToy(null)
      setDefaultPhoto({})
      setSecondPhoto({})
      setThirdPhoto({})
      setFormCityPricing([]) // Reset form city pricing when modal closes
      setIsAddUnitMode(false)
    }
  }, [modal])

  const toggle = () => {
    setModal(!modal)
  }

  const handleToyClick = async arg => {
    try {
      // Fetch fresh data from backend to ensure all populated fields are correct
      const toy = await getToyById(arg._id)

      setDeletedPhotos([])
      setToy({
        _id: toy._id,
        status: toy.status,
        name: toy.name,
        category: toy.category,
        ageGroup: toy.ageGroup,
        mrp: toy.mrp,
        purchase: toy.purchase,
        description: toy.description,
        brand: toy.brand,
        youtubeUrl: toy.youtubeUrl,
        cityPricing: JSON.parse(JSON.stringify(toy.cityPricing)),
        showOnWebsite: toy.showOnWebsite,
        deposit: toy.deposit,
        featured: toy.featured,
        purchaseSource: toy.purchaseSource,
        purchaseDate: toy.purchaseDate
          ? moment(toy.purchaseDate).format("YYYY-MM-DD")
          : null,
        code: toy.code,
      })

      setFeatured(toy.featured)
      setShowOnWebsite(toy.showOnWebsite)

      if (toy.defaultPhoto) {
        setDefaultPhoto({
          src: toy?.defaultPhoto,
          error: "",
          uploading: false,
        })
      }

      if (toy.photo2) {
        setSecondPhoto({
          src: toy?.photo2,
          error: "",
          uploading: false,
        })
      }

      if (toy.photo3) {
        setThirdPhoto({
          src: toy?.photo3,
          error: "",
          uploading: false,
        })
      }
      setIsEdit(true)
      setIsAddUnitMode(false)
      toggle()
      setactiveTab("details")
    } catch (error) {
      console.log("Error in handleToyClick::", error)
      toast.error("Failed to fetch toy details")
    }
  }

  //delete toy
  const [deleteModal, setDeleteModal] = useState(false)

  const onClickDelete = toy => {
    setToy(toy)
    setDeleteModal(true)
  }

  const handleDeleteToy = () => {
    if (toy && toy._id) {
      dispatch(onDeleteToy(toy._id))
      setDeleteModal(false)
    }
  }
  const handleToyClicks = () => {
    setactiveTab("details")
    setToy({
      _id: 0,
      status: "",
      name: "",
      category: [],
      ageGroup: [],
      mrp: "",
      purchase: "",
      description: "",
      brand: "",
      youtubeUrl: "",
      cityPricing: [],
      showOnWebsite: false,
      deposit: "",
      featured: false,
      purchaseSource: "",
      purchaseDate: "",
    })
    setShowOnWebsite(false)
    setFeatured(false)
    setIsEdit(false)
    setIsAddUnitMode(false)
    setFormCityPricing([])
    toggle()
  }

  const handleAddUnit = row => {
    const toy = row.original.toy || row.original

    setDeletedPhotos([])
    setToy({
      _id: null,
      status: ORDER_STATUS.AVAILABLE,
      name: toy.name,
      category: toy.category,
      ageGroup: toy.ageGroup,
      mrp: toy.mrp,
      purchase: toy.purchase,
      description: toy.description,
      brand: toy.brand,
      youtubeUrl: toy.youtubeUrl,
      cityPricing: toy.cityPricing
        ? JSON.parse(JSON.stringify(toy.cityPricing))
        : [],
      showOnWebsite: toy.showOnWebsite,
      deposit: toy.deposit,
      featured: toy.featured,
      purchaseSource: toy.purchaseSource,
      purchaseDate: toy.purchaseDate
        ? moment(toy.purchaseDate).format("YYYY-MM-DD")
        : null,
      defaultPhoto: toy.defaultPhoto,
      photo2: toy.photo2,
      photo3: toy.photo3,
      code: toy.code,
    })

    setFeatured(toy.featured)
    setShowOnWebsite(toy.showOnWebsite)

    if (toy.defaultPhoto) {
      setDefaultPhoto({
        src: toy?.defaultPhoto,
        error: "",
        uploading: false,
      })
    }

    if (toy.photo2) {
      setSecondPhoto({
        src: toy?.photo2,
        error: "",
        uploading: false,
      })
    }

    if (toy.photo3) {
      setThirdPhoto({
        src: toy?.photo3,
        error: "",
        uploading: false,
      })
    }

    setIsEdit(false)
    setIsAddUnitMode(true)
    toggle()
    setactiveTab("pricing")
  }

  const toggleTab = tab => {
    if (activeTab !== tab) {
      setactiveTab(tab)
    }
  }

  const handleFileInputChange = async (event, setPhotoState, key, data) => {
    const file = event.target.files[0]
    if (file) {
      if (validateFileType(file) && validateFileSize(file)) {
        try {
          const formData = new FormData()
          formData.append("image", file)
          if (toy._id && toy._id !== 0) {
            formData.append("_id", toy._id)
          }
          formData.append("key", key)

          setPhotoState({ ...data, uploading: true })
          const response = await post("toys/uploadImage", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })

          if (response.status === 200) {
            const imagePath = response.path || URL.createObjectURL(file)
            setDeletedPhotos(prev => prev.filter(p => p !== key));
            setPhotoState({
              src: imagePath,
              error: "",
              uploading: false
            });
            // setToy(prevToy => ({
            //   ...prevToy,
            //   [key]: imagePath,
            //   cityPricing: JSON.parse(JSON.stringify(formCityPricing))
            // }));
            setToy({ ...toy, [key]: imagePath, cityPricing: formCityPricing })
          } else {
            setPhotoState({
              ...data,
              error: "Error in uploading image",
              uploading: false,
            })
          }
        } catch (error) {
          setPhotoState({
            ...data,
            error: "Error in uploading image",
            uploading: false,
          })
        }
      } else {
        setPhotoState({
          ...data,
          error:
            "Please select a valid image file (png, jpg, jpeg) with a maximum size of 2MB.",
          uploading: false,
        })
      }
    }
  }

  const validateFileType = file => {
    const allowedTypes = ["image/png", "image/jpeg", "image/jpg"]
    return allowedTypes.includes(file.type)
  }

  const validateFileSize = file => {
    const maxSize = 2 * 1024 * 1024 // 2MB in bytes
    return file.size <= maxSize
  }

  const changeCityPricing = (e, week, city) => {
    let price = parseFloat(e.target.value)
    if (isNaN(price)) {
      price = 0
    }

    setFormCityPricing(prevPricing =>
      prevPricing.map(p =>
        p?.city?._id?.toString() === city?.toString()
          ? { ...p, [week]: price }
          : p,
      ),
    )
  }

  const changeCityActivation = (e, city) => {
    const isChecked = e.target.checked
    setFormCityPricing(prevPricing =>
      prevPricing.map(p =>
        p?.city?._id?.toString() === city?.toString()
          ? { ...p, active: isChecked }
          : p,
      ),
    )
  }

  const [isCanvasOpen, setIsCanvasOpen] = useState(false)
  const [selectedToy, setSelectedToy] = useState({})

  const toggleCanvas = () => {
    setIsCanvasOpen(!isCanvasOpen)
  }

  const onToyClick = toyDetails => {
    toggleCanvas()
    setSelectedToy(toyDetails)
  }

  const [orderChecked, setOrderChecked] = useState([])
  const [allChecked, setAllChecked] = useState(false)
  const [openChangeStatusModal, setOpenChangeStatusModal] = useState(false)
  const [toysStatus, setToysStatus] = useState("")

  const handleToyStatusClick = async () => {
    try {
      if (toysStatus === "") {
        toast.error("Please select status")
        return
      }
      const res = await post("toys/updateStatus", {
        toys: orderChecked,
        status: toysStatus,
      })
      if (res.success) {
        toast.success("Status updated successfully")
        setOpenChangeStatusModal(false)
        dispatch(
          onGetToys(
            page,
            limit,
            query,
            toyStatusFilter,
            toyCategoryFilter,
            selectedCity,
            toyShowFilter,
            toyFeaturedFilter,
          ),
        )
        setToysStatus("")
        setOrderChecked([])
        setAllChecked(false)
      }
    } catch (error) {
      let msg = error.response.data.error || "Error in updating toy status"
      toast.error(msg)
      console.log("Error in updating toy status::", error)
    }
  }

  const columns = useMemo(
    () => [
      {
        Header: "Toy Name",
        accessor: "name",
        filterable: true,
        Cell: row => {
          return <>{row?.row?.original?.name}</>
        },
      },
      {
        Header: "Category",
        accessor: "category",
        filterable: true,
        Cell: row => {
          return (
            <>
              {row?.row?.original?.category?.map((category, index) => (
                <div key={index}>
                  {index === row?.row?.original?.category?.length - 1
                    ? category.name
                    : category.name + ", "}
                </div>
              ))}
            </>
          )
        },
      },
      {
        Header: "Age Group",
        accessor: "ageGroup",
        filterable: true,
        Cell: row => {
          return (
            <>
              {row?.row?.original?.ageGroup?.map((age, index) => (
                <div key={index}>
                  {index === row?.row?.original?.ageGroup?.length - 1
                    ? `${age.fromAge} - ${age.toAge} Years`
                    : `${age.fromAge} - ${age.toAge} Years, `}
                </div>
              ))}
            </>
          )
        },
      },
      {
        Header: "Total Units",
        accessor: "variantCount",
        Cell: row => {
          return (
            <Badge className="bg-primary">
              {row?.row?.original?.variantCount || 0} Units
            </Badge>
          )
        },
      },
      {
        Header: "Status Summary",
        accessor: "status",
        Cell: row => {
          // We can show a breakdown if available, but for now just show valid counts or "Active"
          const variants = row?.row?.original?.variants || []
          const available = variants.filter(
            v => v.status === ORDER_STATUS.AVAILABLE,
          ).length
          return (
            <span>
              {available} Available / {variants.length} Total
            </span>
          )
        },
      },
      {
        Header: "Actions",
        accessor: "action",
        disableFilters: true,
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3">
              <span className="text-secondary" style={{ fontSize: "0.8rem" }}>
                Click row to expand
              </span>
            </div>
          )
        },
      },
    ],
    [selectedCity],
  )

  // Method to render specific variant row
  const renderRowSubComponent = row => {
    const variants = row.original.variants || []
    return (
      <Card className="mb-0 border-0 bg-light">
        <CardBody>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h6 className="m-0">Toy Units</h6>
            <Button
              color="primary"
              size="sm"
              onClick={() => handleAddUnit(row)}
            >
              Add Unit
            </Button>
          </div>

          <Table
            className="table-bordered align-middle table-nowrap mb-0"
            style={{ background: "#fff" }}
          >
            <thead>
              <tr>
                <th>Code</th>
                <th>Status</th>
                <th>Purchase Date</th>
                <th>2 Weeks Rent</th>
                <th>3 Weeks Rent</th>
                <th>4 Weeks Rent</th>
                <th>Deposit</th>
                <th>Active Cities</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {variants.map(variant => {
                // City Logic
                let w2 = 0,
                  w3 = 0,
                  w4 = 0
                let activeCityName = ""

                if (selectedCity === "All") {
                  // Find the first ACTIVE pricing
                  const activePricing =
                    variant.cityPricing?.find(cp => cp.active) ||
                    variant.cityPricing?.[0]
                  w2 = activePricing?.w2 || 0
                  w3 = activePricing?.w3 || 0
                  w4 = activePricing?.w4 || 0
                } else {
                  const cityP = variant.cityPricing?.find(c => c.city === selectedCity || c.city?._id === selectedCity);
                  // const cityP = variant.cityPricing?.find(c => {
                  //   const cId = (c.city?._id || c.city)?.toString()
                  //   return cId === selectedCity?.toString()
                  // })
                  w2 = cityP?.w2 || 0
                  w3 = cityP?.w3 || 0
                  w4 = cityP?.w4 || 0
                }

                return (
                  <tr key={variant._id}>
                    <td>{variant.code}</td>
                    <td>{variant.status}</td>
                    <td>
                      {variant.purchaseDate
                        ? moment(variant.purchaseDate).format("DD-MM-YYYY")
                        : "-"}
                    </td>
                    <td>₹ {w2}</td>
                    <td>₹ {w3}</td>
                    <td>₹ {w4}</td>
                    <td>₹ {variant.deposit || 0}</td>
                    <td>
                      {variant.cityPricing
                        ?.filter(cp => cp.active)
                        .map(cp => {
                          const cId = (cp.city?._id || cp.city)?.toString()
                          const cityObj = cities?.find(
                            c => c._id?.toString() === cId,
                          )
                          return cityObj ? cityObj.name : ""
                        })
                        .filter(Boolean)
                        .join(", ")}
                    </td>
                    <td>
                      <div className="d-flex gap-3">
                        <Link
                          to="#"
                          className="text-success"
                          onClick={() => {
                            handleToyClick(variant)
                          }}
                        >
                          <i
                            className="mdi mdi-pencil font-size-18"
                            id={`edit-${variant._id}`}
                          />
                          <UncontrolledTooltip
                            placement="top"
                            target={`edit-${variant._id}`}
                          >
                            Edit
                          </UncontrolledTooltip>
                        </Link>
                        <Link to={`/order-history?toyId=${variant._id}`}>
                          <i
                            className="mdi mdi-eye font-size-18"
                            id={`view-${variant._id}`}
                          />
                          <UncontrolledTooltip
                            placement="top"
                            target={`view-${variant._id}`}
                          >
                            History
                          </UncontrolledTooltip>
                        </Link>
                        <Link
                          to="#"
                          className="text-danger"
                          onClick={() => {
                            onClickDelete(variant)
                          }}
                        >
                          <i
                            className="mdi mdi-delete font-size-18"
                            id={`del-${variant._id}`}
                          />
                          <UncontrolledTooltip
                            placement="top"
                            target={`del-${variant._id}`}
                          >
                            Delete
                          </UncontrolledTooltip>
                        </Link>
                      </div>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </Table>
        </CardBody>
      </Card>
    )
  }

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteToy}
        onCloseClick={() => setDeleteModal(false)}
        title={"Toy"}
      />

      {/* Bulk Update Confirmation Modal */}
      <Modal
        isOpen={bulkUpdateModal}
        toggle={() => setBulkUpdateModal(false)}
        centered
      >
        <ModalHeader toggle={() => setBulkUpdateModal(false)}>
          Update Toy
        </ModalHeader>
        <ModalBody>
          <div className="text-center p-3">
            <i className="mdi mdi-information-outline display-4 text-info mb-3"></i>
            <h4>Confirm Update Range</h4>
            <p className="text-muted">
              Do you want to apply these changes to{" "}
              <strong>only this unit</strong> or to <strong>all units</strong>{" "}
              of this toy?
            </p>
            <div className="hstack gap-2 justify-content-center mt-4">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  setBulkUpdateModal(false)
                  executeSubmit(pendingValues, false)
                }}
              >
                Only This Unit
              </button>
              <button
                type="button"
                className="btn btn-success"
                onClick={() => {
                  setBulkUpdateModal(false)
                  executeSubmit(pendingValues, true)
                }}
              >
                All Units
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setBulkUpdateModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>

      {/* Photo Delete Confirmation Modal */}
      <Modal
        size="md"
        isOpen={photoDeleteModal}
        toggle={cancelDeletePhoto}
        centered={true}
      >
        <div className="modal-content">
          <ModalBody className="px-4 py-5 text-center">
            <button
              type="button"
              onClick={cancelDeletePhoto}
              className="btn-close position-absolute end-0 top-0 m-3"
            ></button>
            <div className="avatar-sm mb-4 mx-auto">
              <div className="avatar-title bg-danger text-danger bg-opacity-10 font-size-20 rounded-3">
                <i className="mdi mdi-delete"></i>
              </div>
            </div>
            <p className="text-muted font-size-16 mb-4">
              Are you sure you want to delete this photo?
            </p>

            <div className="hstack gap-2 justify-content-center mb-0">
              <button
                type="button"
                className="btn btn-danger"
                onClick={confirmDeletePhoto}
              >
                Delete Photo
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={cancelDeletePhoto}
              >
                Cancel
              </button>
            </div>
          </ModalBody>
        </div>
      </Modal>

      <ChangeToyStatusModal
        show={openChangeStatusModal}
        onUpdateClick={() => handleToyStatusClick()}
        onCloseClick={() => {
          setOpenChangeStatusModal(false)
          setToysStatus("")
        }}
        toysStatus={toysStatus}
        setToysStatus={setToysStatus}
      />

      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Masters" breadcrumbItem="Toys" />

          {/* Note about city selection for pricing */}
          {selectedCity === "All" && (
            <Row className="mb-3">
              <Col xs="12">
                <div className="alert alert-info" role="alert">
                  <i className="mdi mdi-information-outline me-2"></i>
                  <strong>Note:</strong> To see toy prices, please select a city
                  from the filter above.
                </div>
              </Col>
            </Row>
          )}

          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <TableContainer
                    title={"Toy"}
                    columns={columns}
                    data={toys}
                    // isGlobalFilter={true}
                    isAddOptions={true}
                    isCustomGlobalFilter={true}
                    setQuery={setQuery}
                    query={query}
                    handleOrderClicks={handleToyClicks}
                    customPageSize={limit}
                    setLimit={setLimit}
                    // isPagination={true}
                    filterable={false}
                    iscustomPageSizeOptions={true}
                    isCustomPagination={true}
                    tableClass="align-middle table-check"
                    theadClass="table-light"
                    pagination="pagination pagination-rounded justify-content-end mb-2"
                    setPage={setPage}
                    pageNumber={page}
                    totals={totalPages}
                    orderChecked={orderChecked}
                    setOrderChecked={setOrderChecked}
                    allChecked={allChecked}
                    setAllChecked={setAllChecked}
                    isCheckable={true}
                    // setOrderStatus,
                    toyPage={true}
                    setOpenChangeStatusModal={setOpenChangeStatusModal}
                    toyStatusFilter={toyStatusFilter}
                    setToyStatusFilter={setToyStatusFilter}
                    toyCategoryFilter={toyCategoryFilter}
                    setToyCategoryFilter={setToyCategoryFilter}
                    categories={categories}
                    toyShowFilter={toyShowFilter}
                    setToyShowFilter={setToyShowFilter}
                    toyFeaturedFilter={toyFeaturedFilter}
                    setToyFeaturedFilter={setToyFeaturedFilter}
                    city={selectedCity}
                    setCity={setSelectedCity}
                    isCityFilter={true}
                    cities={cities}
                    renderRowSubComponent={renderRowSubComponent}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal size="lg" isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle} tag="h4">
              {!!isEdit
                ? "Edit Toy"
                : isAddUnitMode
                  ? "Add Toy Unit"
                  : "Add Toy"}
            </ModalHeader>
            <ModalBody>
              <Form
                onSubmit={e => {
                  e.preventDefault()
                  validation.handleSubmit()
                  return false
                }}
              >
                <Nav tabs className="nav-tabs-custom">
                  {!isAddUnitMode && (
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "details",
                        })}
                        onClick={() => {
                          toggleTab("details")
                        }}
                      >
                        Toy Details
                      </NavLink>
                    </NavItem>
                  )}

                  {!isAddUnitMode && (
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "photoVideo",
                        })}
                        onClick={() => {
                          toggleTab("photoVideo")
                        }}
                      >
                        Photo & Video
                      </NavLink>
                    </NavItem>
                  )}

                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: activeTab === "pricing",
                      })}
                      onClick={() => {
                        toggleTab("pricing")
                      }}
                    >
                      Pricing
                    </NavLink>
                  </NavItem>

                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: activeTab === "quantity",
                      })}
                      onClick={() => {
                        toggleTab("quantity")
                      }}
                    >
                      Quantity
                    </NavLink>
                  </NavItem>
                </Nav>

                <TabContent activeTab={activeTab} className="p-3 text-muted">
                  {/*save in availability field of backend */}
                  <TabPane tabId="details">
                    <Row>
                      <Col sm="12">
                        <CardText className="mb-0">
                          <Row className="mb-4">
                            <Label
                              htmlFor="horizontal-firstname-Input"
                              className="col-sm-3 col-form-label"
                            >
                              Toy name
                            </Label>
                            <Col sm={9}>
                              <Input
                                name="toyName"
                                type="text"
                                className="form-control"
                                id="horizontal-firstname-Input"
                                placeholder="Enter Toy Name"
                                validate={{
                                  required: { value: true },
                                }}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.toyName || ""}
                                invalid={
                                  validation.touched.toyName &&
                                  validation.errors.toyName
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.toyName &&
                              validation.errors.toyName ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.toyName}
                                </FormFeedback>
                              ) : null}
                            </Col>
                          </Row>
                        </CardText>
                      </Col>
                    </Row>
                    <Row className="mb-4">
                      <Label className="col-sm-3 col-form-label">
                        Category
                      </Label>
                      <Col sm={9}>
                        <Select
                          isMulti
                          className="react-select-container"
                          classNamePrefix="react-select"
                          name="categories"
                          options={options}
                          value={options.filter(option =>
                            validation.values.categories.includes(option.value),
                          )}
                          onChange={selectedOptions => {
                            validation.setFieldValue(
                              "categories",
                              selectedOptions.map(option => option.value),
                            )
                          }}
                        />
                        {validation.touched.categories &&
                        validation.errors.categories ? (
                          <FormFeedback type="invalid" className="d-block">
                            {validation.errors.categories}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>
                    <Row className="mb-4">
                      <Label className="col-sm-3 col-form-label">
                        Age Group
                      </Label>
                      <Col sm={9}>
                        {/* Multiple options */}
                        <Select
                          isMulti
                          name="ageGroup"
                          className="react-select-container"
                          classNamePrefix="react-select"
                          options={ageGroupOptions}
                          value={ageGroupOptions.filter(option =>
                            validation.values.ageGroup.includes(option.value),
                          )}
                          onChange={selectedOptions =>
                            validation.setFieldValue(
                              "ageGroup",
                              selectedOptions.map(option => option.value),
                            )
                          }
                        />
                        {validation.touched.ageGroup &&
                        validation.errors.ageGroup ? (
                          <FormFeedback type="invalid" className="d-block">
                            {validation.errors.ageGroup}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>
                    <Row className="mb-4">
                      <Label className="col-sm-3 col-form-label">
                        Toy Description
                      </Label>
                      <Col sm={9}>
                        <Input
                          name="description"
                          type="textarea"
                          className="form-control"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.description || ""}
                        ></Input>
                        {validation.touched.description &&
                        validation.errors.description ? (
                          <FormFeedback type="invalid" className="d-block">
                            {validation.errors.description}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Label className="col-sm-3 col-form-label">Brand</Label>
                      <Col sm={9}>
                        <Input
                          name="brand"
                          type="text"
                          placeholder="Brand"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.brand || ""}
                          invalid={
                            validation.touched.brand && validation.errors.brand
                              ? true
                              : false
                          }
                        />
                        {validation.touched.brand && validation.errors.brand ? (
                          <FormFeedback type="invalid">
                            {validation.errors.brand}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-sm-3 col-form-label">Status</Label>
                      <Col sm={9}>
                        <Input
                          name="status"
                          type="select"
                          className="form-select"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.status || ""}
                        >
                          <option value="">Select Availability</option>
                          <option value={ORDER_STATUS.AVAILABLE}>
                            {ORDER_STATUS.AVAILABLE}
                          </option>
                          <option value={ORDER_STATUS.RENTED}>
                            {ORDER_STATUS.RENTED}
                          </option>
                          <option value={ORDER_STATUS.ONHOLD}>
                            {ORDER_STATUS.ONHOLD}
                          </option>
                          <option value={ORDER_STATUS.CLEANING}>
                            {ORDER_STATUS.CLEANING}
                          </option>
                          <option value={ORDER_STATUS.BROKEN}>
                            {ORDER_STATUS.BROKEN}
                          </option>
                          <option value={ORDER_STATUS.MAINTENANCE}>
                            {ORDER_STATUS.MAINTENANCE}
                          </option>
                        </Input>
                        {validation.touched.status &&
                        validation.errors.status ? (
                          <FormFeedback type="invalid" className="d-block">
                            {validation.errors.status}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>
                    {/* Toy Toggle: */}
                    <Row className="mb-3">
                      <Label className="col-sm-3 col-form-label">
                        Show on Website
                      </Label>
                      <Col sm={9}>
                        <div className="form-check form-switch">
                          <Input
                            name="showOnWebsite"
                            type="checkbox"
                            className="form-check-input"
                            checked={showOnWebsite}
                            value={validation.values.showOnWebsite || false}
                            onChange={() => setShowOnWebsite(!showOnWebsite)}
                          />
                          <Label className="form-check-label">
                            {showOnWebsite ? "Yes" : "No"}
                          </Label>
                        </div>
                      </Col>
                    </Row>
                    {/* Featured Toy Toggle  */}
                    <Row className="mb-3">
                      <Label className="col-sm-3 col-form-label">
                        Featured
                      </Label>
                      <Col sm={9}>
                        <div className="form-check form-switch">
                          <Input
                            name="featured"
                            type="checkbox"
                            className="form-check-input"
                            checked={featured}
                            value={validation.values.featured || false}
                            onChange={() => setFeatured(!featured)}
                          />
                          <Label className="form-check-label">
                            {featured ? "Yes" : "No"}
                          </Label>
                        </div>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="photoVideo">
                    <Row className="mb-3">
                      <Label className="col-sm-3 col-form-label">
                        <strong>Default Photo</strong>
                      </Label>
                      <Col sm={9}>
                        <Input
                          name="image"
                          type="file"
                          accept="image/png, image/jpeg, image/jpg"
                          placeholder="Select toy photo"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={e =>
                            handleFileInputChange(
                              e,
                              setDefaultPhoto,
                              "defaultPhoto",
                              defaultPhoto,
                            )
                          }
                        />

                        {defaultPhoto?.src && (
                          <div className="position-relative d-inline-block me-2">
                            <img
                              src={defaultPhoto?.src}
                              alt="Default"
                              className="preview-image"
                            />
                            <button
                              type="button"
                              className="btn btn-sm btn-danger position-absolute top-0 end-0 rounded-circle d-flex align-items-center justify-content-center p-0 border border-white shadow"
                              style={{
                                width: "32px",
                                height: "32px",
                                zIndex: 10,
                              }}
                              onClick={() => handleDeleteImage("defaultPhoto")}
                            >
                              <i className="mdi mdi-delete font-size-16"></i>
                            </button>
                          </div>
                        )}
                        {defaultPhoto.uploading && (
                          <span className="text-warning">
                            Uploading <i className="fa fas-spinner spin"></i>
                          </span>
                        )}
                        {defaultPhoto.error && (
                          <span className="text-danger">
                            {defaultPhoto.error}
                          </span>
                        )}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Label className="col-sm-3 col-form-label">
                        <strong>Photo 2</strong>
                      </Label>
                      <Col sm={9}>
                        <Input
                          name="image"
                          type="file"
                          accept="image/png, image/jpeg, image/jpg"
                          placeholder="Select toy photo"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={e =>
                            handleFileInputChange(
                              e,
                              setSecondPhoto,
                              "photo2",
                              secondPhoto,
                            )
                          }
                        />
                        {secondPhoto?.src && (
                          <div className="position-relative d-inline-block me-2">
                            <img
                              src={secondPhoto?.src}
                              alt="Photo 2"
                              className="preview-image"
                            />
                            <button
                              type="button"
                              className="btn btn-sm btn-danger position-absolute top-0 end-0 rounded-circle d-flex align-items-center justify-content-center p-0 border border-white shadow"
                              style={{
                                width: "32px",
                                height: "32px",
                                zIndex: 10,
                              }}
                              onClick={() => handleDeleteImage("photo2")}
                            >
                              <i className="mdi mdi-delete font-size-16"></i>
                            </button>
                          </div>
                        )}
                        {secondPhoto.uploading && (
                          <span className="text-warning">
                            Uploading <i className="fa fas-spinner spin"></i>
                          </span>
                        )}
                        {secondPhoto.error && (
                          <span className="text-danger">
                            {secondPhoto.error}
                          </span>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-sm-3 col-form-label">
                        <strong>Photo 3</strong>
                      </Label>
                      <Col sm={9}>
                        <Input
                          name="image"
                          type="file"
                          accept="image/png, image/jpeg, image/jpg"
                          placeholder="Select toy photo"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={e =>
                            handleFileInputChange(
                              e,
                              setThirdPhoto,
                              "photo3",
                              thirdPhoto,
                            )
                          }
                        />
                        {thirdPhoto?.src && (
                          <div className="position-relative d-inline-block me-2">
                            <img
                              src={thirdPhoto?.src}
                              alt="Photo 3"
                              className="preview-image"
                            />
                            <button
                              type="button"
                              className="btn btn-sm btn-danger position-absolute top-0 end-0 rounded-circle d-flex align-items-center justify-content-center p-0 border border-white shadow"
                              style={{
                                width: "32px",
                                height: "32px",
                                zIndex: 10,
                              }}
                              onClick={() => handleDeleteImage("photo3")}
                            >
                              <i className="mdi mdi-delete font-size-16"></i>
                            </button>
                          </div>
                        )}
                        {thirdPhoto.uploading && (
                          <span className="text-warning">
                            Uploading <i className="fa fas-spinner spin"></i>
                          </span>
                        )}
                        {thirdPhoto.error && (
                          <span className="text-danger">
                            {thirdPhoto.error}
                          </span>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-sm-3 col-form-label">
                        YouTube Video
                      </Label>
                      <Col sm={9}>
                        <Input
                          name="youtubeUrl"
                          type="text"
                          placeholder="Paste youtube video link here"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.youtubeUrl || ""}
                          invalid={
                            validation.touched.youtubeUrl &&
                            validation.errors.youtubeUrl
                              ? true
                              : false
                          }
                        />
                        {validation.touched.youtubeUrl &&
                        validation.errors.youtubeUrl ? (
                          <FormFeedback type="invalid">
                            {validation.errors.youtubeUrl}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="pricing">
                    <Row>
                      <Col>
                        <div className="table-responsive">
                          <Table className="table table-bordered border-primary mb-0">
                            <thead>
                              <tr>
                                <th>City</th>
                                <th>2 Week</th>
                                <th>3 Week</th>
                                <th>4 Week</th>
                                <th>Active</th>
                              </tr>
                            </thead>
                            <tbody>
                              {formCityPricing.map(pricing => (
                                <tr key={pricing.city?._id}>
                                  <td>{pricing.city?.name}</td>
                                  <td>
                                    <Input
                                      name="price"
                                      type="text"
                                      placeholder=""
                                      validate={{
                                        required: { value: true },
                                      }}
                                      value={pricing?.w2}
                                      onChange={e =>
                                        changeCityPricing(
                                          e,
                                          "w2",
                                          pricing?.city?._id,
                                        )
                                      }
                                    />
                                  </td>
                                  <td>
                                    <Input
                                      name="price"
                                      type="text"
                                      placeholder=""
                                      validate={{
                                        required: { value: true },
                                      }}
                                      value={pricing?.w3}
                                      onChange={e =>
                                        changeCityPricing(
                                          e,
                                          "w3",
                                          pricing?.city?._id,
                                        )
                                      }
                                    />
                                  </td>
                                  <td>
                                    <Input
                                      name="price"
                                      type="text"
                                      placeholder=""
                                      validate={{
                                        required: { value: true },
                                      }}
                                      value={pricing?.w4}
                                      onChange={e =>
                                        changeCityPricing(
                                          e,
                                          "w4",
                                          pricing?.city?._id,
                                        )
                                      }
                                    />
                                  </td>

                                  <td>
                                    <div className="form-check form-switch">
                                      <Input
                                        name="active"
                                        type="checkbox"
                                        className="form-check-input"
                                        placeholder=""
                                        checked={pricing?.active || false}
                                        value={pricing?.active || false}
                                        onChange={e =>
                                          changeCityActivation(
                                            e,
                                            pricing?.city?._id,
                                          )
                                        }
                                      />
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>
                      </Col>
                    </Row>
                    <Row className="mt-4">
                      <Col sm="12">
                        <Row className="mb-3">
                          <Col sm={3}>
                            <Label className="col-form-label">MRP</Label>

                            <Input
                              name="mrp"
                              type="text"
                              placeholder="MRP amount"
                              validate={{
                                required: { value: true },
                              }}
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.mrp || ""}
                              invalid={
                                validation.touched.mrp && validation.errors.mrp
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.mrp && validation.errors.mrp ? (
                              <FormFeedback type="invalid">
                                {validation.errors.mrp}
                              </FormFeedback>
                            ) : null}
                          </Col>
                          <Col sm={3}>
                            <Label className="col-form-label text-end">
                              Purchase
                            </Label>

                            <Input
                              name="purchase"
                              type="text"
                              placeholder="Purchase amount"
                              validate={{
                                required: { value: true },
                              }}
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.purchase || ""}
                              invalid={
                                validation.touched.purchase &&
                                validation.errors.purchase
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.purchase &&
                            validation.errors.purchase ? (
                              <FormFeedback type="invalid">
                                {validation.errors.purchase}
                              </FormFeedback>
                            ) : null}
                          </Col>

                          <Col sm={3}>
                            <Label className="col-form-label text-end">
                              Purchase Date
                            </Label>

                            <Input
                              name="purchaseDate"
                              type="date"
                              placeholder="Purchase Date"
                              validate={{
                                required: { value: true },
                              }}
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.purchaseDate || ""}
                              invalid={
                                validation.touched.purchaseDate &&
                                validation.errors.purchaseDate
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.purchaseDate &&
                            validation.errors.purchaseDate ? (
                              <FormFeedback type="invalid">
                                {validation.errors.purchaseDate}
                              </FormFeedback>
                            ) : null}
                          </Col>

                          <Col sm={3}>
                            <Label className="col-form-label text-end">
                              Purchase Source
                            </Label>

                            <Input
                              name="purchaseSource"
                              type="text"
                              placeholder="Purchase Source"
                              validate={{
                                required: { value: true },
                              }}
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.purchaseSource || ""}
                              invalid={
                                validation.touched.purchaseSource &&
                                validation.errors.purchaseSource
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.purchaseSource &&
                            validation.errors.purchaseSource ? (
                              <FormFeedback type="invalid">
                                {validation.errors.purchaseSource}
                              </FormFeedback>
                            ) : null}
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col sm={3}>
                        <Label className="col-form-label text-end">
                          Deposit
                        </Label>

                        <Input
                          name="deposit"
                          type="text"
                          placeholder="Deposit"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.deposit || ""}
                          invalid={
                            validation.touched.deposit &&
                            validation.errors.deposit
                              ? true
                              : false
                          }
                        />
                        {validation.touched.deposit &&
                        validation.errors.deposit ? (
                          <FormFeedback type="invalid">
                            {validation.errors.deposit}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="quantity">
                    <Row className="mb-3">
                      <Col sm={12}>
                        <Label className="col-form-label">
                          Quantity{" "}
                          {(isEdit || isAddUnitMode) && (
                            <span
                              className="text-muted"
                              style={{ fontSize: "12px" }}
                            >
                              (Add new units)
                            </span>
                          )}
                        </Label>
                        <Input
                          name="quantity"
                          type="number"
                          placeholder="Check quantity"
                          min={isEdit ? 0 : 1}
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.quantity}
                        />
                      </Col>
                    </Row>
                  </TabPane>
                </TabContent>

                <Row>
                  <Col>
                    <div className="text-end">
                      {isSubmitting ? (
                        <button
                          type="button"
                          className="btn btn-success"
                          disabled
                        >
                          Processing...
                        </button>
                      ) : (
                        <button
                          type="submit"
                          className="btn btn-success save-user"
                        >
                          {isEdit ? `Update Toy` : "Save Toy"}
                        </button>
                      )}
                      <button
                        type="button"
                        className="btn btn-secondary ms-2"
                        onClick={() => {
                          setModal(false)
                          setFormCityPricing([]) // Reset form data when closing
                        }}
                      >
                        Close
                      </button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>
        </div>
      </div>
      <ToastContainer />
    </React.Fragment>
  )
}
Toys.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default Toys
